import { render, staticRenderFns } from "./ProjectsPg.vue?vue&type=template&id=08a0214e&scoped=true&"
import script from "./ProjectsPg.vue?vue&type=script&lang=js&"
export * from "./ProjectsPg.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsPg.vue?vue&type=style&index=0&id=08a0214e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a0214e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
